/** Placeholders de carregamento — evita "tela em branco" enquanto a API
 * responde. Composição sobre `Card`/`Skeleton` de `@argink/ui`. */
import { Card, Skeleton } from '@argink/ui';

export function DocumentCardSkeleton() {
  return (
    <Card aria-busy="true">
      <Skeleton lines={4} label="Carregando informações do documento" />
    </Card>
  );
}

export function CertListSkeleton() {
  return (
    <div className="cert-list" aria-busy="true">
      <Card>
        <Skeleton lines={3} label="Carregando certificados" />
      </Card>
      <Card variant="flat">
        {/* label vazio no segundo bloco — evita anunciar "Carregando" duas vezes
         * para leitor de tela; o primeiro Card já cobre o grupo inteiro. */}
        <Skeleton lines={3} label="" />
      </Card>
    </div>
  );
}
